export const STATUS_BADGES = {
  delivered: { label: 'Delivered', background: 'var(--color-badge-info-bg)', color: 'var(--color-success)' },
  bounced: { label: 'Failed', background: 'var(--color-badge-error-bg)', color: 'var(--color-error)' },
  failed: { label: 'Failed', background: 'var(--color-badge-error-bg)', color: 'var(--color-error)' },
  pending: { label: 'Not delivered yet', background: 'var(--color-badge-warn-bg)', color: 'var(--color-badge-warn-text)' },
};

export const STATUS_FILTER_OPTIONS = [
  { label: 'Delivered', value: 'delivered' },
  { label: 'Failed', value: 'failed' },
  { label: 'Not delivered yet', value: 'pending' },
];

export const ALL_STATUSES = STATUS_FILTER_OPTIONS.map((o) => o.value);

export function toRowStatus(status) {
  if (status === 'delivered') return 'delivered';
  if (status === 'sent') return 'pending';
  return 'failed';
}
